<template>
  <div class="py-4">
    <template v-if="position.users.length === 0">
      <BaseAlert>{{ $t('no-players-for-this-position-available') }}</BaseAlert>
    </template>
    <template v-else>
      <ThePlayerScoreRow
        v-for="user in position.users"
        :key="user.id"
        :name="user.name"
        :avatar="user.avatar"
      />
    </template>
  </div>
</template>

<script>
import ThePlayerScoreRow from '@/components/Molecules/ThePlayerScoreRow'
import BaseAlert from '@/components/Atoms/BaseAlert'
export default {
  name: 'ThePositionPlayersOverview',
  components: {
    BaseAlert,
    ThePlayerScoreRow,
  },
  props: {
    position: {
      type: Object,
      required: true,
    },
  },
}
</script>
